import { redirectToLogin } from "./annoucement-sheet";
import { api, getLanguageCodeForbackend } from "./api";
import authHeader from "./auth-header";
import { getAuthUser } from "./dashboard";
export type DropdownDataWithLanguage = {
  id: number;
  name_en: string;
  name_tc: string;
  name_sc: string;
};
type DepartmentsResponse = {
  module_id: number;
  status: boolean;
  data: DepartmentInfo[];
  total: number;
};

export type TData = {
  data: DepartmentInfo[];
  total: number;
};
export type DepartmentInfo = {
  id?: number;
  name: string;
};
export type TaskDepartmentList = {
  dataList: TaskDepartmentListData[];
};
export type TaskDepartmentListData = {
  id: number;
  name_en: string;
  name_tc: string;
  name_sc: string;
  link_en: string;
  link_tc: string;
  link_sc: string;
};
export type IDepartPaginationData = {
  page: number;
  limit: number | string | undefined;
  search: string | number;
  sort?: string;
};
export const portalApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMobileLandingPages: build.query<
      any,
      void
    >({
      query: () => {
        return ({
          url: `${getLanguageCodeForbackend()}mobile-portal-links`,
          headers: authHeader(),
        })
      },
      keepUnusedDataFor: 0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
  }),
});

export const {
  useGetMobileLandingPagesQuery,
} = portalApi;

export const {
  endpoints: {
    getMobileLandingPages
  },
} = portalApi;
